import { Link, Outlet } from 'react-router';

import { env } from '@/config/env';
import { ROUTES } from '@/app/router/routes';

/**
 * Coquille commune à toutes les pages : en-tête, zone de contenu, pied de page.
 * `<Outlet />` est l'emplacement où React Router injecte la page courante.
 */
export const RootLayout = () => (
  <div className="flex min-h-dvh flex-col bg-slate-50 text-slate-900">
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
        <Link to={ROUTES.home} className="text-lg font-semibold tracking-tight">
          {env.VITE_APP_NAME}
          <span className="ml-2 rounded bg-slate-900 px-2 py-0.5 text-xs font-medium text-white">
            ATS
          </span>
        </Link>
      </div>
    </header>

    <main className="mx-auto w-full max-w-5xl flex-1 px-6 py-10">
      <Outlet />
    </main>

    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-5xl px-6 py-4 text-sm text-slate-500">
        {env.VITE_APP_NAME} — environnement de développement
      </div>
    </footer>
  </div>
);
